import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  AutocompleteInput,
  DateInput,
  ReferenceInput,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
  usePermissions,
} from 'react-admin';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { CatalogItemAutocompleteInput, Toolbar } from '../../../components';
import { getUser } from '../../../user';

const sanitizeRestProps = ({
  hasShow,
  hasEdit,
  hasList,
  hasCreate,
  ...props
}) => {
  return props;
};

const parseDate = (value) => {
  if (value === '') {
    return null;
  }
  return moment(value).format('YYYY-MM');
};

const InvoiceIncubatorForm = ({ onCancel, record, ...props }) => {
  // Fail closed: rely on react-admin permissions, fall back to the stored
  // user while the async AUTH_GET_PERMISSIONS call hasn't resolved yet (same
  // repli pattern as Cleaner/detail/Form.js and
  // Vivier/components/WarningsCard.js). This form is mounted by
  // InvoiceIncubator/List.js's DrawerCreateEdit, not by a react-admin
  // <Resource edit=/> route, but usePermissions() only needs the AuthContext
  // provided at <Admin> level, so it works the same inside the Drawer.
  const { permissions } = usePermissions();
  const user = permissions || getUser();

  // Mirror the server-side check (postgRest.js: hasPermission(user,
  // 'invoice_incubator', 'delete', 1)) instead of a hardcoded role test,
  // same motif as Cleaner/detail/Form.js. `isCreate` keeps the button off
  // the Create screen (this Form is shared by InvoiceIncubator/Create.js and
  // InvoiceIncubator/Edit.js, both rendered by the Drawer).
  const isCreate = !record || !record.id;
  const isDeletable =
    !isCreate && !!(user?.permissions?.invoice_incubator?.delete >= 1);

  return (
    <Fragment>
      <div style={{ textAlign: 'right' }}>
        <IconButton onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </div>
      <SimpleForm
        {...sanitizeRestProps(props)}
        record={{ ...record, generated: false }}
        toolbar={<Toolbar isDeletable={isDeletable} />}
      >
        <DateInput source="month" parse={parseDate} />
        <ReferenceInput
          filterToQuery={(searchText) => {
            return { name: searchText };
          }}
          source="account_id"
          reference="account"
          validate={[required()]}
        >
          <AutocompleteInput
            source="name"
            options={{
              suggestionsContainerProps: {
                /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
                style: { zIndex: 2000 },
              },
            }}
          />
        </ReferenceInput>
        <ReferenceInput
          filterToQuery={(searchText) => {
            return { name: searchText };
          }}
          source="billing_id"
          reference="account"
          validate={[required()]}
        >
          <AutocompleteInput
            source="name"
            options={{
              suggestionsContainerProps: {
                /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
                style: { zIndex: 2000 },
              },
            }}
          />
        </ReferenceInput>
        <CatalogItemAutocompleteInput
          validate={[required()]}
          source="product"
          options={{
            suggestionsContainerProps: {
              /* XXX: no other way to give style to the AutocompleList. react-admin not passing classes to AutocompleList in AutocompleInput */
              style: { zIndex: 2000 },
            },
          }}
        />
        <TextInput source="description" />
        <NumberInput source="price" step={0.01} validate={[required()]} />
      </SimpleForm>
    </Fragment>
  );
};

InvoiceIncubatorForm.propTypes = {
  onCancel: PropTypes.func,
  record: PropTypes.object,
};

InvoiceIncubatorForm.defaultProps = {
  onCancel: /* istanbul ignore next */ () => {},
  record: {},
};

export default InvoiceIncubatorForm;
